import React from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import pick from './utilities/pick'
import mapDispatchers from './utilities/mapDispatchers'
import getStartLocationForUser from './utilities/getStartLocationForUser'
import styles from './Login.icss'
import FacebookAuthButton from './components/FacebookAuthButton'
import InstagramAuthButton from './components/InstagramAuthButton'
import EmailAuthButton from './components/EmailAuthButton'
import Img from './components/Img'
import ImageCarousel from './components/ImageCarousel'

const renderMessage = txt => (
	<span key={txt.text}>
		{txt.dampen && (
			<span className={styles.dampenText}>{txt.text}</span>
		)}
		{!txt.dampen &&
			<b>{txt.text}</b>
		}
	</span>
)

class Login extends React.Component {
	static getDerivedStateFromProps(props) {
		const userName = props && props.match && props.match.params ?
			props.match.params.username :
			null

		return { userName }
	}

	constructor(props, context) {
		super(props)
		this.handleOnChange = this.handleOnChange.bind(this)

		const that = { context }

		//	Welcome text and and associated images
		this.welcomeTexts = [{
			top: [
				{ text: that.context.translate('Kit that '), dampen: true },
				{ text: that.context.translate('you will love') }
			],
			bottom: [
				{ text: that.context.translate('Proven by '), dampen: true },
				{ text: that.context.translate('friends and professionals') }
			],
			images: ['/images/login/1_1.jpg', '/images/login/1_2.jpg', '/images/login/1_3.jpg', '/images/login/1_4.jpg', '/images/login/1_5.jpg']
		},
		{
			top: [
				{ text: that.context.translate('Kit that '), dampen: true },
				{ text: that.context.translate('works') }
			],
			bottom: [
				{ text: that.context.translate('So you can '), dampen: true },
				{ text: that.context.translate('do what you love') }
			],
			images: ['/images/login/2_1.jpg', '/images/login/2_2.jpg', '/images/login/2_3.jpg', '/images/login/2_4.jpg', '/images/login/2_5.jpg', '/images/login/2_6.jpg']
		},
		{
			top: [
				{ text: that.context.translate('Kit that '), dampen: true },
				{ text: that.context.translate('fits you') }
			],
			bottom: [
				{ text: that.context.translate('And the Kit you '), dampen: true },
				{ text: that.context.translate('already own') }
			],
			images: ['/images/login/3_1.jpg', '/images/login/3_2.jpg', '/images/login/3_3.jpg', '/images/login/3_4.jpg']
		},
		{
			top: [
				{ text: that.context.translate('Qualify as a KF '), dampen: true },
				{ text: that.context.translate('Ambassador') }
			],
			bottom: [
				{ text: that.context.translate('Get ') },
				{ text: that.context.translate('what you '), dampen: true },
				{ text: that.context.translate('Give') }
			],
			images: ['/images/login/1_1.jpg', '/images/login/1_2.jpg', '/images/login/1_3.jpg', '/images/login/1_4.jpg', '/images/login/1_5.jpg']
		}]

		const images = this.welcomeTexts.map(wt => wt.images[parseInt(Math.random() * wt.images.length, 10)])
		this.state = {
			welcomeText: null,
			imageIndex: 0,
			images
		}
	}

	componentDidMount() {
		this.props.appBackButtonFunction(false)
		this.props.appShowTopBar(false)
		this.props.appShowBottomBar(false)
		const imageIndex = this.state.imageIndex
		if (!this.state.welcomeText) {
			this.setState({
				welcomeText: this.welcomeTexts[imageIndex]
			})
		}
	}

	componentDidUpdate() {
		if ((this.props.authFacebookLoginSuccess || this.props.authInstagramLoginSuccess) &&
			!this.props.user.isAnonymous && !this.props.user.isLoading) {
			this.props.appRedirect(getStartLocationForUser(this.props.user))
		}
	}

	componentWillUnmount() {
		this.props.authReset()
	}

	handleOnChange(myImageIndex) {
		let imageIndex = myImageIndex
		let welcomeText = this.welcomeTexts[imageIndex]
		if (!welcomeText) {
			imageIndex = 0
			welcomeText = this.welcomeTexts[imageIndex]
		}
		this.setState({ imageIndex, welcomeText })
	}

	render() {
		return (
			<div className={styles.loginWrapper}>
				<section className={styles.welcomeWrapper}>
					<h2><Img className={styles.logo} content="/images/logo/kitfit-logo-white.svg" /></h2>
					<p className={styles.welcomeParagraph}>
						{this.state.welcomeText && this.state.welcomeText.top.map(renderMessage) }
					</p>
					<p className={styles.postParagraph}>
						{this.state.welcomeText && this.state.welcomeText.bottom.map(renderMessage) }
					</p>
				</section>
				<section className={styles.imageWrapper}>
					{this.state.welcomeText && (
						<ImageCarousel
							className={styles.imageCarousel}
							images={this.state.images}
							infinite
							autoplay
							cover
							dots={false}
							arrows={false}
							onChange={this.handleOnChange}
						/>
					)}
					<div className={styles.imageShadowTop} />
					<div className={styles.imageShadowBottom} />
				</section>
				<section className={styles.actionsWrapper}>
					<div className={styles.buttonWrapper}>
						<InstagramAuthButton />
						<FacebookAuthButton />
						<EmailAuthButton />
					</div>
				</section>
				<section className={styles.termsPrivacy}>
					<a href="https://kit.fit/terms" target="_blank" rel="noreferrer noopener" className={styles.tpLink}>{this.context.translate('Terms of use')}</a>
					<a href="https://kit.fit/privacy" target="_blank" rel="noreferrer noopener" className={styles.tpLink}>{this.context.translate('Privacy')}</a>
				</section>
			</div>
		)
	}
}

Login.contextTypes = {
	translate: PropTypes.func
}

Login.propTypes = {
	appBackButtonFunction: PropTypes.func.isRequired,
	appShowTopBar: PropTypes.func.isRequired,
	appShowBottomBar: PropTypes.func.isRequired,
	appRedirect: PropTypes.func.isRequired,
	authReset: PropTypes.func.isRequired,
	authFacebookLoginSuccess: PropTypes.bool,
	authInstagramLoginSuccess: PropTypes.bool,
	user: PropTypes.object, // eslint-disable-line react/forbid-prop-types
	match: PropTypes.shape({
		params: PropTypes.object.isRequired
	}).isRequired
}

Login.defaultProps = {
	authFacebookLoginSuccess: false,
	authInstagramLoginSuccess: false,
	user: undefined
}

export const testing = {
	Login
}

export default connect(
	/* istanbul ignore next line */
	state => pick(state, ['user', 'authFacebookLoginSuccess', 'authInstagramLoginSuccess']),
	/* istanbul ignore next line */
	dispatch => mapDispatchers(dispatch, ['appBackButtonFunction', 'appShowTopBar', 'appShowBottomBar', 'appRedirect', 'authReset'])
)(Login)



// WEBPACK FOOTER //
// ./src/Login.jsx